import api from 'services/api';

export const updateSpicificNote = async (
  videoHashId: string,
  noteHashId: string,
  data: { content: string; time: any }
): Promise<any> => {
  // https://demo.squoia.com/api/videos/note/{note_id}/
  // https://demo.squoia.com/api/videos/note/{note_id}/
  const response = await api.patch(`/api/videos/note/${noteHashId}/`, data);
  return response;
};

export const deleteSpecificNote = async (noteHashId: string): Promise<any> => {
  // https://demo.squoia.com/api/videos/note/{note_id}/
  const response = await api.delete(`/api/videos/note/${noteHashId}/`);
  return response;
};
